import {upperFirst} from "@pg-mono/nodash";
import {areaFormat, pluralize} from "@pg-mono/string-utils";

import {ILocationGenericSection, ILocationGenericSectionProps, ParagraphType} from "../constants";

export const getFlatsRoomRangeSectionTexts = (props: ILocationGenericSectionProps): ILocationGenericSection["paragraphs"] => {
    const getGeneralPropertyCountText = (propertiesCount: number) => {
        return `${propertiesCount} ${pluralize(["lokal", "lokale", "lokali"])(propertiesCount)}`;
    };

    const hasFlatsWithRoomRange = (roomRangeToCheck: number) => {
        const roomRangeRecord = props.region.stats?.properties_flats_rooms_ranges?.[roomRangeToCheck];
        return !!roomRangeRecord && roomRangeRecord > 0;
    };

    const hasAnyFlatsRoomRange = () => {
        return hasFlatsWithRoomRange(1) || hasFlatsWithRoomRange(2) || hasFlatsWithRoomRange(3) || hasFlatsWithRoomRange(4) || hasFlatsWithRoomRange(5);
    };

    const getFlatGroupedByRoomRange = (roomRange: number) => {
        return props.region.stats?.properties_flats_rooms_ranges[roomRange] || 0;
    };

    const variables = {
        regionNameDeclensionWhere: props.region.name_declension_where,
        regionOfferCountForSale: props.region.stats?.offers_count_for_sale || 0,
        propertiesFlatsRangesAreaMin: props.region.stats?.properties_flats_ranges_area_min || 0,
        regionPropertiesCountForSale: props.region.stats?.properties_all_count_for_sale || 0,
        propertiesFlatsRangesAreaMax: props.region.stats?.properties_flats_ranges_area_max || 0
    };

    return hasAnyFlatsRoomRange()
        ? [
              {
                  type: ParagraphType.TEXT,
                  text: `Deweloperzy ${props.region.name_declension_where} mają w sprzedaży nowe ${pluralize([
                      `mieszkanie o powierzchni ${areaFormat(variables.propertiesFlatsRangesAreaMin)}`,
                      `mieszkania powierzchniach od ${variables.propertiesFlatsRangesAreaMin} do ${areaFormat(variables.propertiesFlatsRangesAreaMax)}`,
                      `mieszkania powierzchniach od ${variables.propertiesFlatsRangesAreaMin} do ${areaFormat(variables.propertiesFlatsRangesAreaMax)}`
                  ])(variables.regionPropertiesCountForSale)}, w tym:`
              },
              {
                  type: ParagraphType.LIST,
                  text: [
                      hasFlatsWithRoomRange(1) && `kawalerki - ${getGeneralPropertyCountText(getFlatGroupedByRoomRange(1))}`,
                      hasFlatsWithRoomRange(2) && `mieszkania 2-pokojowe - ${getGeneralPropertyCountText(getFlatGroupedByRoomRange(2))}`,
                      hasFlatsWithRoomRange(3) && `mieszkania 3-pokojowe - ${getGeneralPropertyCountText(getFlatGroupedByRoomRange(3))}`,
                      hasFlatsWithRoomRange(4) && `mieszkania 4-pokojowe - ${getGeneralPropertyCountText(getFlatGroupedByRoomRange(4))}`,
                      hasFlatsWithRoomRange(5) && `mieszkania 5-pokojowe i więcej - ${getGeneralPropertyCountText(getFlatGroupedByRoomRange(5))}`
                  ].filter(Boolean) as string[]
              }
          ]
        : [
              {
                  type: ParagraphType.TEXT,
                  text: `${upperFirst(variables.regionNameDeclensionWhere)} nie znajdziemy w ofercie sprzedaży nowych mieszkań.`
              }
          ];
};
import {upperFirst} from "@pg-mono/nodash";
import {areaFormat, pluralize} from "@pg-mono/string-utils";

import {ILocationGenericSection, ILocationGenericSectionProps, ParagraphType} from "../constants";

export const getFlatsRoomRangeSectionTexts = (props: ILocationGenericSectionProps): ILocationGenericSection["paragraphs"] => {
    const getGeneralPropertyCountText = (propertiesCount: number) => {
        return `${propertiesCount} ${pluralize(["lokal", "lokale", "lokali"])(propertiesCount)}`;
    };

    const hasFlatsWithRoomRange = (roomRangeToCheck: number) => {
        const roomRangeRecord = props.region.stats?.properties_flats_rooms_ranges?.[roomRangeToCheck];
        return !!roomRangeRecord && roomRangeRecord > 0;
    };

    const hasAnyFlatsRoomRange = () => {
        return hasFlatsWithRoomRange(1) || hasFlatsWithRoomRange(2) || hasFlatsWithRoomRange(3) || hasFlatsWithRoomRange(4) || hasFlatsWithRoomRange(5);
    };

    const getFlatGroupedByRoomRange = (roomRange: number) => {
        return props.region.stats?.properties_flats_rooms_ranges[roomRange] || 0;
    };

    const variables = {
        regionNameDeclensionWhere: props.region.name_declension_where,
        regionOfferCountForSale: props.region.stats?.offers_count_for_sale || 0,
        propertiesFlatsRangesAreaMin: props.region.stats?.properties_flats_ranges_area_min || 0,
        regionPropertiesCountForSale: props.region.stats?.properties_all_count_for_sale || 0,
        propertiesFlatsRangesAreaMax: props.region.stats?.properties_flats_ranges_area_max || 0
    };

    return hasAnyFlatsRoomRange()
        ? [
              {
                  type: ParagraphType.TEXT,
                  text: `Deweloperzy ${props.region.name_declension_where} mają w sprzedaży nowe ${pluralize([
                      `mieszkanie o powierzchni ${areaFormat(variables.propertiesFlatsRangesAreaMin)}`,
                      `mieszkania powierzchniach od ${variables.propertiesFlatsRangesAreaMin} do ${areaFormat(variables.propertiesFlatsRangesAreaMax)}`,
                      `mieszkania powierzchniach od ${variables.propertiesFlatsRangesAreaMin} do ${areaFormat(variables.propertiesFlatsRangesAreaMax)}`
                  ])(variables.regionPropertiesCountForSale)}, w tym:`
              },
              {
                  type: ParagraphType.LIST,
                  text: [
                      hasFlatsWithRoomRange(1) && `kawalerki - ${getGeneralPropertyCountText(getFlatGroupedByRoomRange(1))}`,
                      hasFlatsWithRoomRange(2) && `mieszkania 2-pokojowe - ${getGeneralPropertyCountText(getFlatGroupedByRoomRange(2))}`,
                      hasFlatsWithRoomRange(3) && `mieszkania 3-pokojowe - ${getGeneralPropertyCountText(getFlatGroupedByRoomRange(3))}`,
                      hasFlatsWithRoomRange(4) && `mieszkania 4-pokojowe - ${getGeneralPropertyCountText(getFlatGroupedByRoomRange(4))}`,
                      hasFlatsWithRoomRange(5) && `mieszkania 5-pokojowe i więcej - ${getGeneralPropertyCountText(getFlatGroupedByRoomRange(5))}`
                  ].filter(Boolean) as string[]
              }
          ]
        : [
              {
                  type: ParagraphType.TEXT,
                  text: `${upperFirst(variables.regionNameDeclensionWhere)} nie znajdziemy w ofercie sprzedaży nowych mieszkań.`
              }
          ];
};
